import React__default, { useContext } from 'react';
import { L as LocalizationContext } from '../../chunks/bundle-qXzcabru.js';
import MessageInput from '../../ui/MessageInput.js';
import { u as useOpenChannelContext } from '../../chunks/bundle-8GoMZkJU.js';
import '../../chunks/bundle-Qz8Xvs0V.js';
import '../../chunks/bundle-oJDE4gxT.js';
import '../../chunks/bundle-FpyOg33P.js';
import '../../chunks/bundle-qvWKHgxb.js';
import '../../chunks/bundle-MbdTAPd0.js';
import '../../ui/IconButton.js';
import '../../ui/Button.js';
import '../../chunks/bundle-afcKlUXe.js';
import '../../chunks/bundle-Os1fWxhI.js';
import 'dompurify';
import '../../chunks/bundle-1g6DWJD0.js';
import '../../chunks/bundle-_ZNty2ba.js';
import '../../chunks/bundle-oo5v2vDN.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-ZdB7DVTk.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-HBHAJNcI.js';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-nfdZFsK-.js';
import '../../chunks/bundle-Ey_7-wSi.js';
import '../../chunks/bundle-beh08z4N.js';
import '../../chunks/bundle-_iM6nCNy.js';
import '../../chunks/bundle-tIZkKr0f.js';
import '../../chunks/bundle-PjrYdsK-.js';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../chunks/bundle--bKgEN9C.js';
import '../../chunks/bundle-GPxxY-H1.js';
import '../../chunks/bundle-M5pt2U9r.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-tZpfBaVT.js';
import 'react-dom';
import '../../chunks/bundle-PS5DHcTM.js';
import '../../chunks/bundle-wxDl4Uqr.js';

var OpenChannelInput = React__default.forwardRef(function (props, ref) {
    var _a = useOpenChannelContext(), currentOpenChannel = _a.currentOpenChannel, disabled = _a.disabled, handleSendMessage = _a.handleSendMessage, handleFileUpload = _a.handleFileUpload, amIMuted = _a.amIMuted;
    var channel = currentOpenChannel;
    var stringSet = useContext(LocalizationContext).stringSet;
    var value = props.value;
    function getPlaceHolderString() {
        if (amIMuted) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__MUTED;
        }
        if (disabled) {
            return stringSet.MESSAGE_INPUT__PLACE_HOLDER__DISABLED;
        }
        return '';
    }
    if (!channel) {
        return null;
    }
    return (React__default.createElement("div", { className: "sendbird-openchannel-footer" },
        React__default.createElement(MessageInput, { channel: currentOpenChannel, ref: ref, value: value, disabled: disabled, isVoiceMessageEnabled: false, onSendMessage: handleSendMessage, onFileUpload: handleFileUpload, placeholder: getPlaceHolderString() })));
});

export { OpenChannelInput as default };
//# sourceMappingURL=OpenChannelInput.js.map
